import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
      <path
        fill={props.fill || '#EF3C34'}
        d="M12 13.575a.728.728 0 00.75-.75V8.3c0-.2-.07-.371-.212-.513A.731.731 0 0012 7.575a.728.728 0 00-.75.75v4.525c0 .2.071.37.213.512.141.142.32.213.537.213zm0 3.65a.779.779 0 00.575-.225.779.779 0 00.225-.575.779.779 0 00-.225-.575.779.779 0 00-.575-.225.779.779 0 00-.575.225.779.779 0 00-.225.575c0 .233.075.425.225.575.15.15.342.225.575.225zM12 22a9.263 9.263 0 01-3.712-.75 9.58 9.58 0 01-3.013-2.025 9.58 9.58 0 01-2.025-3.013A9.263 9.263 0 012.5 12.5c0-1.317.25-2.554.75-3.713a9.583 9.583 0 012.025-3.012A9.58 9.58 0 018.288 3.75 9.263 9.263 0 0112 3a9.27 9.27 0 013.713.75 9.583 9.583 0 013.012 2.025 9.583 9.583 0 012.025 3.012 9.27 9.27 0 01.75 3.713c0 1.317-.25 2.554-.75 3.712a9.58 9.58 0 01-2.025 3.013 9.583 9.583 0 01-3.012 2.025A9.27 9.27 0 0112 22zm0-1.5c2.217 0 4.104-.779 5.663-2.337C19.221 16.604 20 14.717 20 12.5s-.779-4.104-2.337-5.663C16.104 5.279 14.217 4.5 12 4.5s-4.104.779-5.662 2.337C4.779 8.396 4 10.283 4 12.5s.78 4.104 2.338 5.663C7.896 19.721 9.783 20.5 12 20.5z"
      ></path>
    </svg>
  );
}

export default Icon;
